// Friendly, admin-facing messages for registration write failures.
// Raw PostgreSQL text must never reach the UI — log it, don't display it.

const CODE_MESSAGES: Record<string, string> = {
  not_authorized: "You do not have permission to change this registration.",
  registration_not_found:
    "We could not remove this registration because its internal record could not be identified.",
  session_label_required: "Pick a session before saving.",
  live_payment_protected:
    "This is a live payment record and cannot be deleted. Use refund, void, or hide instead.",
};

export function friendlyRegistrationError(error: unknown): string {
  const raw =
    typeof error === "string"
      ? error
      : (error as { message?: string } | null)?.message ?? "";

  for (const [code, message] of Object.entries(CODE_MESSAGES)) {
    if (raw.includes(code)) return message;
  }
  if (/invalid input syntax for type uuid/i.test(raw)) {
    return "We could not remove this registration because its internal record could not be identified.";
  }
  if (/permission denied|row-level security|42501/i.test(raw)) {
    return "You do not have permission to change this registration.";
  }
  if (/fetch|network|Failed to send/i.test(raw)) {
    return "We could not reach the server. Check your connection and try again.";
  }
  return "Something went wrong saving that change. Nothing was deleted — please try again.";
}
